// extracted by mini-css-extract-plugin
module.exports = {"pageExcerpt":"e_Hk"};